import Crud from '../views/Grupo/Crud'
import Add from '../views/Grupo/Add'

let routes = {
    path: '/grupos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/grupos',
            name: 'list-grupos',
            component: Crud,
            meta: {
                pageTitle: "Lista de grupos",
                breadcrumb: [
                    {
                        text: "grupos",
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/grupos/add',
            name: 'NewGrupo',
            component: Add,
            meta: {
                pageTitle: 'Criação de grupos',
                breadcrumb: [
                    {
                        text: 'grupos',
                        active: false,
                        to: '/grupos',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/grupos/edit/:id?',
            name: 'ViewGrupo',
            component: Add,
            meta: {
                pageTitle: "Editar Grupo",
                breadcrumb: [
                    {
                        text: "grupos",
                        active: false,
                        to: '/grupos',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
    ]
};


export default routes
